"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreUpdateToJSON = exports.StoreUpdateFromJSONTyped = exports.StoreUpdateFromJSON = exports.instanceOfStoreUpdate = exports.StoreUpdateHeroLogoVisibilityEnum = exports.StoreUpdateHeaderLogoTypeEnum = exports.StoreUpdateStatusEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.StoreUpdateStatusEnum = {
    Draft: 'draft',
    Open: 'open',
    Closed: 'closed'
};
/**
 * @export
 */
exports.StoreUpdateHeaderLogoTypeEnum = {
    Text: 'text',
    Logo: 'logo',
    CustomInkBranding: 'custom_ink_branding'
};
/**
 * @export
 */
exports.StoreUpdateHeroLogoVisibilityEnum = {
    Hidden: 'hidden',
    HeroLogo: 'hero_logo',
    HeroBackground: 'hero_background',
    HeroLogoAndBackground: 'hero_logo_and_background'
};
/**
 * Check if a given object implements the StoreUpdate interface.
 */
function instanceOfStoreUpdate(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStoreUpdate = instanceOfStoreUpdate;
function StoreUpdateFromJSON(json) {
    return StoreUpdateFromJSONTyped(json, false);
}
exports.StoreUpdateFromJSON = StoreUpdateFromJSON;
function StoreUpdateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'logo': !(0, runtime_1.exists)(json, 'logo') ? undefined : json['logo'],
        'heroImage': !(0, runtime_1.exists)(json, 'hero_image') ? undefined : json['hero_image'],
        'headerLogoType': !(0, runtime_1.exists)(json, 'header_logo_type') ? undefined : json['header_logo_type'],
        'heroLogoVisibility': !(0, runtime_1.exists)(json, 'hero_logo_visibility') ? undefined : json['hero_logo_visibility'],
        'headerBackgroundColor': !(0, runtime_1.exists)(json, 'header_background_color') ? undefined : json['header_background_color'],
        'bannerEnabled': !(0, runtime_1.exists)(json, 'banner_enabled') ? undefined : json['banner_enabled'],
        'bannerText': !(0, runtime_1.exists)(json, 'banner_text') ? undefined : json['banner_text'],
    };
}
exports.StoreUpdateFromJSONTyped = StoreUpdateFromJSONTyped;
function StoreUpdateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'status': value.status,
        'logo': value.logo,
        'hero_image': value.heroImage,
        'header_logo_type': value.headerLogoType,
        'hero_logo_visibility': value.heroLogoVisibility,
        'header_background_color': value.headerBackgroundColor,
        'banner_enabled': value.bannerEnabled,
        'banner_text': value.bannerText,
    };
}
exports.StoreUpdateToJSON = StoreUpdateToJSON;
